import { Api } from '@/services/Api'

export default {
  getDataV2(plantId, device, params) {
    return Api().get(`/api/v2/sld/${plantId}/${device}/${encodeURIComponent(params)}`).then(res => res.data.message)
  },
  getComputedDataV2(plantId, device) {
    return Api().get(`/api/v2/sld/computed/${plantId}/${device}`).then(res => res.data.message)
  },
  getSymbol(sldId) {
    return Api().get(`/api/v1.0/symbol/${sldId}`).then(res => res.data.message)
  },
  getSVGimage(param) {
    return Api().get(`/api/v1.0/svg/${param}`).then(res => res.data)
  }
}
